import Player from "@vimeo/player";

if (!customElements.get("video-snippet")) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector("video, .video");
      this.player = null;
      this.isVimeo = "vimeo" in this.video.dataset;

      if (this.video) {
        this.init();
      }

      this.timeout = null;
    }

    get src() {
      const isMobile = window.matchMedia(this.dataset.mediaQuery);
      const src = this.video.dataset.mediaSrc;
      const mobileSrc =
        "mediaSrcMobile" in this.video.dataset
          ? this.video.dataset.mediaSrcMobile
          : src;
      return isMobile.matches ? mobileSrc : src;
    }

    init() {
      if (this.isVimeo) {
        this.vimeoSrc = this.src;
        this.player = new Player(this.video, {
          id: this.vimeoSrc,
        });

        this.player.on("play", () => {
          this.classList.add("playing");
        });
      }

      this.checkVideo();

      this.listenForEnd();

      window.addEventListener("resize", () => {
        clearTimeout(this.timeout);
        setTimeout(() => {
          this.checkVideo();
        }, 200);
      });

      this.addEventListener("video-component:play", () => {
        if (this.isVimeo) {
          this.player.play();
        } else {
          this.video.play();
        }
      });

      this.addEventListener("video-component:pause", () => {
        if (this.isVimeo) {
          this.player.pause();
        } else {
          this.video.pause();
        }
      });
    }

    checkFillDirection() {
      if (!this.isVimeo) return;

      Promise.all([
        this.player.getVideoWidth(),
        this.player.getVideoHeight(),
      ]).then((dimensions) => {
        const { width, height } = this.getBoundingClientRect();
        const [videoWidth, videoHeight] = dimensions;

        const containerAR = width / height;
        const videoAR = videoWidth / videoHeight;

        this.classList.toggle("fill-horizontal", videoAR <= containerAR);
        this.classList.toggle("fill-vertical", videoAR > containerAR);
      });
    }

    checkVideo() {
      // Only update src if it has changed, to avoid flickering on resize
      if (this.isVimeo) {
        if (this.src !== this.vimeoSrc) {
          this.vimeoSrc = this.src;
          this.player.loadVideo(this.vimeoSrc).then(() => {
            this.checkFillDirection();
          });
        } else {
          this.checkFillDirection();
        }
      } else {
        if (this.src !== this.video.src) {
          this.video.src = this.src;
        }
      }
    }

    listenForEnd() {
      if (this.isVimeo) {
        this.player.on("ended", () => {
          const event = new CustomEvent("video:ended", {
            bubbles: true,
          });

          this.dispatchEvent(event);
        });
      } else {
        this.video.addEventListener("ended", () => {
          const event = new CustomEvent("video:ended", {
            bubbles: true,
          });

          this.dispatchEvent(event);
        });
      }
    }
  }

  customElements.define("video-snippet", VideoComponent);
}
